export default __webpack_public_path__ + "static/media/step2.70eaf333.jpeg";